import { render, staticRenderFns } from "./RegistriesView.vue?vue&type=template&id=2d7b540f&scoped=true"
import script from "./RegistriesView.vue?vue&type=script&lang=js"
export * from "./RegistriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b540f",
  null
  
)

export default component.exports